import _typeof from "@babel/runtime/helpers/typeof";
import t from '@zenlayer/zen-intl18';
import { all, equals, isNil } from 'ramda'; // --------Required----------

export var strRequiredMsg = function strRequiredMsg(field) {
  return t('i3JAmyka9Vei');
};
/**
 * 用于验证传入的值是否为空或者无效
 * @function
 * @param {string} field 字段名称，用于标识要验证的字段
 * @param {string | number} val 要验证的值，可以是字符串或数字
 */

export var strRequired = function strRequired(field) {
  return function (val) {
    switch (_typeof(val)) {
      case 'string':
        if (!val.trim()) {
          throw strRequiredMsg();
        }

        break;

      default:
        if (isNil(val)) {
          throw strRequiredMsg();
        }

        break;
    }
  };
};
export var selectRequiredMsg = function selectRequiredMsg(field) {
  return t('XujdWih3W51z');
};
/**
 * 用于验证选中的值是否为空或者无效
 * @function
 * @param {string} field 字段名称，用于标识要验证的字段
 * @param {string | number} val 要验证的值，可以是字符串或数字
 */

export var selectRequired = function selectRequired(field) {
  return function (val) {
    switch (_typeof(val)) {
      case 'string':
        if (!val.trim()) {
          throw selectRequiredMsg();
        }

        break;

      default:
        if (isNil(val)) {
          throw selectRequiredMsg();
        }

        break;
    }
  };
}; // --------Between----------

/**
 * 用于验证输入值是否在对应范围内
 * @function
 * @param {number} lower 最小长度
 * @param {number} upper 最大长度
 */

export var numberBetween = function numberBetween(lower, upper) {
  return function (val) {
    var num = parseFloat(val);

    if (num < lower || num > upper) {
      throw t('9oRyQlVQI3SR', [lower, upper]);
    }
  };
};
export var lengthBetweenEqualityMsg = function lengthBetweenEqualityMsg(length) {
  return t('h_HohH4-zLaF', [length]);
};
export var lengthBetweenGreaterMsg = function lengthBetweenGreaterMsg(length) {
  return t('Nc40T-LSP1D4', [length]);
};
export var lengthBetweenLessMsg = function lengthBetweenLessMsg(length) {
  return t('dk4kIWbyFVjt', [length]);
};
/**
 * 用于验证输入值是否在对应范围内
 * @function
 * @param {number} l 最小长度
 * @param {number} u 最大长度
 */

export var lengthBetween = function lengthBetween(l, u) {
  return function (val) {
    var length = val === null || val === void 0 ? void 0 : val.length;

    if (l === u && length !== l) {
      throw lengthBetweenEqualityMsg(l);
    } else if (length < l) {
      throw lengthBetweenGreaterMsg(l);
    } else if (length > u) {
      throw lengthBetweenLessMsg(u);
    }
  };
}; // --------isEmail----------

export var isEmailReg = /^[A-Za-z0-9\._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
export var isEmailMsg = function isEmailMsg() {
  return t('7QTqpGT_uWuy');
};
export var isEmail = function isEmail(value) {
  if (!isEmailReg.test(value)) {
    throw isEmailMsg();
  }
}; // --------isPassword----------

/**
 * 用于验证密码是否符合规范
 * @function
 */

export var isPassword = function isPassword(val) {
  var length = val.length;

  if (length < 8) {
    throw t('kvDGYPeJ58wp');
  }

  if (length > 20) {
    throw t('gtGPxZFuVKKb');
  }

  var valArr = val === null || val === void 0 ? void 0 : val.split('');

  if (all(equals(valArr === null || valArr === void 0 ? void 0 : valArr[0]))(valArr)) {
    throw t('V4MkTCVrX2d0');
  }

  if (!/\d+/.test(val)) {
    throw t('1nh22uJxJjXD');
  }

  if (!/[a-z]+/.test(val)) {
    throw t('1nh22uJxJjXD');
  }

  if (!/[A-Z]+/.test(val)) {
    throw t('1nh22uJxJjXD');
  } // if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]+/.test(val)) {
  //   throw 'special character required';
  // }

};
export var sameWith = function sameWith(field, fieldName, message) {
  return function (val, data) {
    if (val !== data[field]) {
      throw message || t('ufrlDOmax70T', [fieldName]);
    }
  };
};
export var isPureCharacterReg = /^[\u4e00-\u9fa5a-zA-Z0-9~`\!@#\$%…\^&\*\(\)\-_=\+\[\]\{\}\\|;:'",<\.>\/\?·～！¥（）——【】「」、；：‘’“”，。《》？\s]*$/;
export var isPureCharacterMsg = function isPureCharacterMsg() {
  return t('sPFze0XWJ_EB');
};
export var isPureCharacter = function isPureCharacter(val) {
  if (!isPureCharacterReg.test(val)) {
    throw isPureCharacterMsg();
  }
}; //  ----------输入钱的地方----------
//匹配 0.1 0.01 1.1 1.12 100 100.1 100.01
//不匹配 -1 0 0.00

export var amountReg = /(^[1-9]+\d*$)|(^[1-9]+\d*\.[0-9]{1}[1-9]{1}$)|(^[1-9]+\d*\.[1-9]{1}$)|(^0\.[1-9]{1}$)|(^0\.\d{1}[1-9]{1}$)/;
export var firstnameReg = /^[\[\]\u4e00-\u9fa5a-zA-Z0-9\_\`\~\!\@\#\$\%\^\&\*\(\)\_\\\-\+\=\?\:\{\}\|\,\.\/\;\"\'\·\~\！\@\#\￥\%\…\&\*\（\）\—\—\\\-\+\=\{\}\|\《\》\？\：\“\”\【\】\、\；\‘\’\，\。\、\s]*$/;
export var isFirstnameMsg = function isFirstnameMsg() {
  return t('UeU4Zij33NtZ');
};
export var lastnameReg = firstnameReg;
export var isLastnameMsg = function isLastnameMsg() {
  return t('kpDS1TehEwDY');
}; // 全局重命名规则

export var labelNameRule = function labelNameRule() {
  return {
    pattern: /^[a-zA-Z0-9]{1}[a-zA-Z0-9\d.-]{0,61}[a-zA-Z0-9]{1}$/,
    message: t('EfxYC4WbM4Ig')
  };
};